import "./ProjectCard.scss";
import { motion } from "framer-motion";
interface ProjectCardProps {
  title: string;
  index: number;
  image: string;
  framework: any;
  description: string;
  onOpen: () => void;
  onSeeMore: () => void;
}
const cardVariants: any = {
  hidden: { opacity: 0, y: 20 },
  visible: (i: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.15,
      duration: 0.5,
      ease: "easeOut",
    },
  }),
};

const ProjectCard: React.FC<ProjectCardProps> = ({
  title,
  index,
  image,
  framework,
  description,
  onOpen,
  onSeeMore,
}) => {
  return (
    <motion.div 
      className="project-card-container"
      custom={index}
      initial="hidden"
      animate="visible"
      variants={cardVariants}
      whileHover={{ y: -5 }}
      transition={{ type: "spring", stiffness: 300, damping: 20 }}
    >
      <div className="project-card-container__title">
        <span>Project {index + 1} </span>
        {`// ${title}`}
      </div>
      <div className="project-card-container__card">
        <div className="project-card-container__card__framework">
          {framework}
        </div>
        <div
          className="project-card-container__card__image"
          style={{ backgroundImage: `url(${image})` }}
        ></div>
        <div className="project-card-container__card__description">
          <p className="project-card-container__card__description__text">
            {description}
          </p>
          <div className="project-card-container__card__description__actions">
            <button onClick={onOpen} type="button">
              view-project
            </button>
            <button onClick={onSeeMore} type="button">
              see-more
            </button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};
export default ProjectCard;
